'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASSET_ACQUIRE_SUCCESS = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.resetAssetDownload = resetAssetDownload;
exports.requestAssetDownload = requestAssetDownload;
exports.acquireAsset = acquireAsset;

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _utils = require('utils');

var _index = require('../../utils/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESET = 'ms/asset-downloads/reset';

var CREATE = 'ms/asset-downloads/create';
var CREATE_SUCCESS = 'ms/asset-downloads/create_success';
var CREATE_FAIL = 'ms/asset-downloads/create_fail';

var ASSET_ACQUIRE = 'ms/asset-downloads/acquire';

var ASSET_ACQUIRE_SUCCESS = exports.ASSET_ACQUIRE_SUCCESS = 'ms/asset-downloads/acquire_success';
var ASSET_ACQUIRE_FAIL = 'ms/asset-downloads/acquire_fail';

var initialState = {
  downloadRequesting: false,
  assetDownloadLink: null,
  downloadRequestError: null
};

// Reducer

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CREATE:
      return (0, _extends3.default)({}, state, {
        downloadRequesting: true
      });

    case CREATE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        assetDownloadLink: action.result.downloadLink,
        downloadRequesting: false
      });

    case CREATE_FAIL:
      return (0, _extends3.default)({}, state, {
        downloadRequesting: false,
        downloadRequestError: action.error
      });

    case ASSET_ACQUIRE:
      return (0, _extends3.default)({}, state, {
        acquiringAsset: true
      });

    case ASSET_ACQUIRE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        acquiringAsset: false
      });

    case ASSET_ACQUIRE_FAIL:
      return (0, _extends3.default)({}, state, {
        acquiringAsset: false,
        acquiringAssetError: action.error
      });

    case RESET:
      return initialState;

    default:
      return state;
  }
}

// Action creators

function resetAssetDownload() {
  return {
    type: RESET
  };
}

function processComponents(arr, exrAccess) {
  var processedArray = [];

  // Use JPEGs as fallback if user doesn't have access to EXRs
  arr.forEach(function (fc) {
    if (fc.mimeType === 'image/jpeg') {
      if (fc.type === 'displacement' && (exrAccess === 'displacement' || exrAccess === 'full')) {
        processedArray.push((0, _extends3.default)({}, fc, { mimeType: 'image/jpeg' }), (0, _extends3.default)({}, fc, { mimeType: 'image/x-exr' }));
        return;
      }
    }

    if (fc.mimeType === 'image/x-exr') {
      if (fc.type === 'displacement' && (exrAccess === 'displacement' || exrAccess === 'full')) {
        processedArray.push(fc);
        return;
      }

      if (fc.type !== 'displacement' && exrAccess !== 'full') {
        processedArray.push((0, _extends3.default)({}, fc, { mimeType: 'image/jpeg' }));
        return;
      }

      processedArray.push(fc);
      return;
    }

    // Handle JPEG+EXR selection
    if (fc.mimeType === 'jpeg+exr') {
      if (fc.type === 'displacement' && (exrAccess === 'displacement' || exrAccess === 'full')) {
        processedArray.push((0, _extends3.default)({}, fc, { mimeType: 'image/jpeg' }), (0, _extends3.default)({}, fc, { mimeType: 'image/x-exr' }));
        return;
      }

      if (fc.type !== 'displacement' && exrAccess !== 'full') {
        processedArray.push((0, _extends3.default)({}, fc, { mimeType: 'image/jpeg' }));
        return;
      }

      processedArray.push((0, _extends3.default)({}, fc, { mimeType: 'image/jpeg' }), (0, _extends3.default)({}, fc, { mimeType: 'image/x-exr' }));
      return;
    }

    processedArray.push(fc);
  });

  return processedArray;
}

function requestAssetDownload(_ref) {
  var assetId = _ref.assetId,
      asset = _ref.asset,
      isFree = _ref.isFree;

  return function (dispatch, getState) {
    var _getState = getState(),
        settings = _getState.settings,
        user = _getState.user;

    var type = asset.version === 2 && asset.categories[0].toLowerCase().startsWith('3d') ? '3dplant' : asset.categories[0].toLowerCase();
    var typeSettings = settings[type];

    var meshMimeType = typeSettings.meshMimeType,
        lodAlbedos = typeSettings.lodAlbedos,
        lodNormals = typeSettings.lodNormals,
        ztool = typeSettings.ztool,
        brushes = typeSettings.brushes,
        highpoly = typeSettings.highpoly,
        components = typeSettings.components,
        vfx = typeSettings.vfx;
    var resolution = typeSettings.resolution;
    var acl = asset.acl;

    var exrAccess = isFree ? 'full' : acl.exrAccess;

    var maxAssetResolution = (0, _index.getMaxAssetResolution)(asset);

    var accessResolution = maxAssetResolution;
    if (asset.acl && !isFree) {
      accessResolution = Math.min(asset.acl.resolution, maxAssetResolution);
    }

    resolution = Math.min(resolution, accessResolution);

    var lods = undefined;
    var highestLOD = -1;
    if (asset.categories[0].toLowerCase() === '3d' && asset.version !== 2) {
      var settingsLODs = _underscore2.default.values(_underscore2.default.pick(typeSettings, 'lod0', 'lod1', 'lod2', 'lod3', 'lod4', 'lod5', 'lod6', 'lod7', 'lod8'));
      var assetLODs = asset.meshes.filter(function (mesh) {
        return mesh.type === 'lod';
      });
      var sortedAssetLODs = assetLODs.sort(function (a, b) {
        return b.tris - a.tris;
      });
      lods = _underscore2.default.compact(sortedAssetLODs.map(function (lod, index) {
        return settingsLODs[index] ? lod.tris : null;
      }));
      highestLOD = lods.length > 0 ? lods[0] : -1;
    }

    if (asset.categories[0].toLowerCase().startsWith('3d') && asset.version === 2) {
      var meshes = undefined;
      var maps = [];
      var billboards = [];
      var mimeType = typeSettings.mimeType;


      var maxLod = Math.max.apply(Math, (0, _toConsumableArray3.default)(_underscore2.default.uniq(_underscore2.default.pluck(asset.models.filter(function (a) {
        return a.type === 'lod';
      }), 'lod'))));
      var _settingsLODs = _underscore2.default.values(_underscore2.default.pick(typeSettings, 'lod0', 'lod1', 'lod2', 'lod3', 'lod4', 'lod5', 'lod6', 'lod7', 'lod8')).filter(function (l, i) {
        return i <= maxLod;
      });
      // const assetLODs = asset.models.filter((m, i) => i < maxLod);
      meshes = _underscore2.default.compact(_settingsLODs.map(function (lod, index) {
        return _settingsLODs[index] ? { mimeType: 'application/x-fbx', lod: index } : null;
      }));
      maps = [{ mimeType: mimeType, resolution: resolution + 'x' + resolution }, { mimeType: 'image/x-exr', resolution: resolution + 'x' + resolution, type: 'displacement' }];

      // TODO: Fix this when updating 3dplants to 3d version 2
      var isBillboardSelected = asset.version === 2 && asset.categories[0].toLowerCase() !== '3dplant' ? false : _settingsLODs[maxLod];
      var lodsSelected = _underscore2.default.compact(_settingsLODs).length;

      if (isBillboardSelected) {
        billboards = [{ mimeType: mimeType, resolution: resolution + 'x' + resolution }];

        if (lodsSelected === 1) {
          maps = [];
        }
      }

      var processedBillboards = processComponents(billboards, exrAccess);
      var processedMaps = processComponents(maps, exrAccess);

      if (vfx) {
        var assetContainsVFX = asset.models.filter(function (a) {
          return a.type === 'vfx';
        }).length > 0;
        var vfxMesh = { mimeType: 'application/x-fbx', type: 'vfx' };

        if (assetContainsVFX) {
          meshes = meshes.concat(vfxMesh);
        }
      }

      return dispatch({
        types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
        promise: function promise(client) {
          return client.post('v1/downloads', {
            data: (0, _extends3.default)({
              asset: assetId
            }, processedMaps.length > 0 && { components: processedMaps }, asset.categories[0] === '3dplant' && { billboards: processedBillboards.length > 0 ? processedBillboards : false }, {
              meshes: meshes
            })
          }).then(function (a) {
            (0, _utils.downloadAsset)(a.id, !!isFree);
            return a;
          });
        }
      });
    }

    // lowerlod_normals
    var config = (0, _utils.cleanObj)({
      highpoly: highpoly,
      ztool: ztool,
      // maxlod: finalMaxLod,
      lowerlod_normals: lodNormals,
      albedo_lods: lodAlbedos,
      meshMimeType: meshMimeType,
      brushes: brushes,
      lods: lods
    });

    var componentsProp = asset.version === 2 ? 'maps' : asset.components ? 'components' : asset.billboards ? 'billboards' : "";
    var assetComponentTypes = _ramda2.default.compose(_ramda2.default.map(_ramda2.default.prop('type')), _ramda2.default.prop(componentsProp))(asset);

    var prepareComponents = _ramda2.default.compose(_ramda2.default.filter(_ramda2.default.compose(_ramda2.default.contains(_ramda2.default.__, assetComponentTypes), _ramda2.default.prop('type'))), _ramda2.default.map(_ramda2.default.compose(_ramda2.default.assoc('resolution', (0, _utils.getResolutionXRepresentationFromAsset)(resolution, asset)), _ramda2.default.dissoc('selected'))));

    var finalComponents = prepareComponents(components.filter(function (cmp) {
      if (type === '3d') {
        if (cmp.type === 'normal') {
          return lodNormals;
        }
      }
      return cmp.selected;
    }));
    var processedComponents = processComponents(finalComponents, exrAccess);

    if (asset.categories[0].toLowerCase() === '3d') {
      if (lodNormals === false) {
        var normal = components.find(function (cmp) {
          return cmp.type === 'normal';
        });
        if (!_underscore2.default.isEmpty(normal) && normal.selected === true && highestLOD !== -1) {
          if (normal.mimeType === 'jpeg+exr') {
            if (exrAccess !== 'full') {
              processedComponents.push({
                type: 'normal',
                resolution: (0, _utils.getResolutionXRepresentationFromAsset)(resolution, asset),
                mimeType: 'image/jpeg',
                tris: highestLOD
              });
            } else {
              processedComponents.push({
                type: 'normal',
                resolution: (0, _utils.getResolutionXRepresentationFromAsset)(resolution, asset),
                mimeType: 'image/x-exr',
                tris: highestLOD
              }, {
                type: 'normal',
                resolution: (0, _utils.getResolutionXRepresentationFromAsset)(resolution, asset),
                mimeType: 'image/jpeg',
                tris: highestLOD
              });
            }
          } else {
            if (normal.mimeType === 'image/jpeg') {
              processedComponents.push({
                type: 'normal',
                resolution: (0, _utils.getResolutionXRepresentationFromAsset)(resolution, asset),
                mimeType: normal.mimeType,
                tris: highestLOD
              });
            } else {
              // EXR
              if (exrAccess === 'full') {
                processedComponents.push({
                  type: 'normal',
                  resolution: (0, _utils.getResolutionXRepresentationFromAsset)(resolution, asset),
                  mimeType: normal.mimeType,
                  tris: highestLOD
                });
              }
            }
          }
        }
      }
    }

    return dispatch({
      types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
      promise: function promise(client) {
        return client.post('v1/downloads', {
          data: {
            asset: assetId,
            components: processedComponents,
            config: config
          }
        }).then(function (a) {
          (0, _utils.downloadAsset)(a.id, !!isFree);
          return a;
        });
      }
    });
  };
}

function acquireAsset(_ref2) {
  var assetId = _ref2.assetId,
      resolution = _ref2.resolution,
      exrAccess = _ref2.exrAccess,
      cost = _ref2.cost;

  return {
    types: [ASSET_ACQUIRE, ASSET_ACQUIRE_SUCCESS, ASSET_ACQUIRE_FAIL],
    meta: { assetId: assetId, resolution: resolution, exrAccess: exrAccess, cost: cost },
    promise: function promise(client) {
      return client.post('v1/acl', { data: { assetID: assetId } });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/assetDownloads.js
// module id = 314
// module chunks = 0